import { Flag } from 'components/Basic/Flag/Flag';
import { SimpleFlagType } from 'types/flag';
import { ProductDetailType } from 'types/product';

type ProductFlagsProps = {
    isProductDetail: boolean;
    flags: SimpleFlagType[];
    product: ProductDetailType;
};

const testIdentifier = 'blocks-product-detail-flags-';

const ProductDetailFlags: FC<ProductFlagsProps> = (props) => {
    if (props.flags.length === 0) {
        return null;
    }

    return (
        <ul className="absolute right-0 top-0 flex flex-col gap-1">
            {props.flags.map((flag, key) =>
                flag.visible ? (
                    <Flag
                        key={flag.slug}
                        large
                        backgroundColor={flag.rgbColor}
                        className="pointer-events-none mb-2.5 h-[40px] cursor-default self-end px-4 py-0 text-small font-medium"
                        data-testid={testIdentifier + key}
                        fixedWidth={flag.isActionFlag}
                        flagLink={flag.link || flag.slug}
                        isCustomLink={flag.isCustomLink}
                        textColor={flag.textColor}
                    >
                        {flag.isActionFlag && props.product.isInAction
                            ? `-${props.product.actionDiscountPercent} %`
                            : flag.name}
                    </Flag>
                ) : null,
            )}
        </ul>
    );
};

export default ProductDetailFlags;
